module.exports = __webpack_public_path__ + "static/media/5.86c9095e.jpg";